<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="合同名称">
                    <el-input v-model="formInline.contractname"  placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="合同状态">
                   <el-select v-model="formInline.cstatus_desc" placeholder="请选择">
                        <el-option label="尾款未付" value="2"></el-option>
                        <el-option label="付款完成"  value="3"></el-option>
                        <el-option label="进行中"  value="1"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-button type="primary" @click="look(0)" style="margin:20px 20px 0 0;" v-if="user.roleId!=3">添加合同</el-button>
        <span style="margin-right:30px;">未付金额总计:{{zj_wfjine}}</span>
        <span style="margin-right:30px;">已付金额总计:{{zj_yfjine}}</span>
        <span style="margin-right:30px;">预付结算金额总计:{{zj_yjjsjine}}</span>
        <span style="margin-right:30px;">总结算金额总计:{{zj_zjsjine}}</span>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="610px">
            <el-table-column  prop="newId"  label="ID"></el-table-column>
            <el-table-column  prop="contractname"  label="合同名称" show-overflow-tooltip></el-table-column>
            <el-table-column   label="预计结算金额">
                 <template slot-scope="scope">
                      <el-link type="primary"  @click="tc_one(scope.row.id)">{{scope.row.yjjsjine}}</el-link>
                 </template>
            </el-table-column>
            <el-table-column prop="zjsjine"  label="总结算金额" ></el-table-column>
            <el-table-column label="已付金额">
                <template slot-scope="scope">
                      <el-link type="primary"  @click="tc_two(scope.row.id,1)">{{scope.row.yfjine}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="wfjine"  label="未付金额" ></el-table-column>
            <el-table-column prop="cstatus_desc"  label="合同状态" ></el-table-column>
            <el-table-column   label="租赁数量">
                <template slot-scope="scope">
                    <el-link type="danger"  @click="open_zl(scope.row.id)" v-if="scope.row.red>0">{{scope.row.zl_num}}</el-link>
                    <el-link type="primary"  @click="open_zl(scope.row.id)" v-else>{{scope.row.zl_num}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="kp_rgfee"  label="已开票人工费" ></el-table-column>
            <el-table-column prop="kp_zlfee"  label="已开票租赁费" ></el-table-column>
            <el-table-column   label="操作" fixed="right" width="450" header-align="center"> 
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(1,scope.row.id)" style="margin-right:10px;" size="small">查看</el-link>
                    <el-link :underline="false" @click="open_zd(scope.row.id)" style="margin-right:10px;" size="small">开票</el-link>
                    <el-link :underline="false" @click="jiesuan(scope.row.id)" style="margin-right:10px;" size="small">结算</el-link>
                    <el-link :underline="false" @click="tc_two(scope.row.id,2)" style="margin-right:20px;" size="small">付款</el-link>
                    <el-link :underline="false" @click="zulin(scope.row.id)" style="margin-right:20px;" size="small" v-if="scope.row.status==1">租赁设备</el-link>
                    <el-link :underline="false" @click="look(2,scope.row.id)" style="margin-right:20px;" size="small">编辑</el-link>
                     <el-link :underline="false" @click="guanBi(scope.row.id)" style="margin-right:20px;" size="small" v-if="scope.row.status==1">关闭</el-link>
                    <el-link :underline="false" @click="del(scope.row.id)" type="danger" v-if="user.roleId==1">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="70%">
                <el-form :model="form"  :rules="rules" ref="form" label-width="88px">
                    <el-row :gutter="8">
                        <el-col :span="6">
                            <el-form-item label="合同名称" prop="contractname"> 
                                <el-input v-model="form.contractname"  placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合同编号" prop="contractnum">
                                <el-input v-model="form.contractnum" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合同金额">
                                <el-input v-model="form.jine" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合同状态">
                                <el-select v-model="form.cstatus_desc" placeholder="请选择" @change="edit_hetong" style="margin-right:20px;" :disabled="tit_type==1?true:false">
                                    <el-option label="尾款未付" value="2"></el-option>
                                    <el-option label="付款完成"  value="3"></el-option>
                                    <el-option label="进行中"  value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="6">
                            <el-form-item label="合同地址">
                                <el-input v-model="form.address"  placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                       <el-col :span="6" v-if="tit_type!=2">
                            <el-form-item label="停滞折扣" prop="discount"> 
                                <el-input v-model="form.discount"  type="number"  placeholder="请输入"  :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="tit_type!=0">
                            <el-form-item label="总结算金额"> 
                                <el-input v-model="form.zjsjine"  type="number"  placeholder="请输入"  :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col :span="6">
                        <el-form-item label="联系人">
                          <el-button type="primary" icon="el-icon-edit" @click="add_user" v-if="tit_type!=1"></el-button>
                        </el-form-item>
                    </el-col>
                    <el-table ref="multipleTable" :data="form.contact" tooltip-effect="dark" style="width:90%;margin:0 auto"  max-height="180px">
                        <el-table-column   label="姓名">
                            <template slot-scope="scope">
                                <span v-if="tit_type==1">{{scope.row.name}}</span>
                                <el-input v-model="scope.row.name" placeholder="" v-else></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column    label="电话">
                            <template slot-scope="scope">
                                <span v-if="tit_type==1">{{scope.row.tel}}</span>
                                <el-input v-model="scope.row.tel" placeholder="" type="number" v-else></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address"  label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="delUser(scope.$index)" style="margin-right:20px;" size="small" v-if="tit_type!=1">删除</el-link>
                                <span v-else>暂无</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" v-if="tit_type!=1">
                    <el-button type="primary" @click="Submit" v-if="tit_type==0">保存</el-button>
                    <el-button type="primary" @click="editS" v-if="tit_type==2">确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="预计结算金额" :visible.sync="chuKu" width="70%">
               <el-table  :data="tableDatas" border show-summary :summary-method="getSummaries" style="width: 100%">
                    <el-table-column prop="dealtime" label="结算时间" width="180"></el-table-column>
                    <el-table-column  prop="rgfee" label="人工费"> </el-table-column>
                    <el-table-column  prop="zlfee" sortable label="租赁费"></el-table-column>
                    <el-table-column  prop="totalfee" sortable  label="合计"></el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog :title="fk_tit" :visible.sync="Money" width="50%">
                <el-button type="primary" @click="add_Fk" style="margin-bottom:10px;" v-if="fk_type==2">添加付款</el-button>
                <el-table  :data="tableDataTwo" border show-summary :summary-method="getSummariess" style="width: 100%">
                    <el-table-column prop="dealtime" label="付款时间" ></el-table-column>
                    <el-table-column prop="rgfee" label="付款金额"></el-table-column>
                    <el-table-column   label="操作" v-if="fk_type==2">
                         <template slot-scope="scope">
                            <el-link :underline="false" @click="jseditfk(scope.row)" style="margin-right:20px;" size="small">修改</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog title="开票" :visible.sync="zd" width="70%">
                <el-button type="primary" @click="add_js(1)" style="margin-bottom:10px;">添加开票</el-button>
                <el-table  :data="tableDatakp" border show-summary :summary-method="getSummaries_s" style="width: 100%">
                    <el-table-column prop="dealtime" label="开票时间" width="180"></el-table-column>
                    <el-table-column  prop="rgfee" label="人工费"> </el-table-column>
                    <el-table-column  prop="zlfee" sortable label="租赁费"></el-table-column>
                    <!-- <el-table-column  prop="totalfee" sortable  label="合计"></el-table-column> -->
                    <el-table-column prop="address"  label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="jsedit(scope.row,1)" style="margin-right:20px;" size="small">修改</el-link>
                            <el-link type="danger" :underline="false" @click="del_js(scope.row.id,1)" style="margin-right:20px;" size="small">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog title="结算" :visible.sync="JS" width="70%">
                <el-button type="primary" @click="add_js(0)" style="margin-bottom:10px;">添加结算</el-button>
                <el-table  :data="tableDatas" border show-summary :summary-method="getSummaries" style="width: 100%">
                    <el-table-column prop="dealtime" label="结算时间" width="180"></el-table-column>
                    <el-table-column  prop="rgfee" label="人工费"> </el-table-column>
                    <el-table-column  prop="zlfee" sortable label="租赁费"></el-table-column>
                    <el-table-column  prop="totalfee" sortable  label="合计"></el-table-column>
                    <el-table-column prop="address"  label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="jsedit(scope.row,0)" style="margin-right:20px;" size="small">修改</el-link>
                            <el-link type="danger" :underline="false" @click="del_js(scope.row.id,0)" style="margin-right:20px;" size="small">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog :title="js_tit_two" :visible.sync="JSedit" width="50%">
                <el-form :inline="true" :model="JS_edit_list" class="demo-form-inline">
                    <el-row :gutter="10">
                        <el-form-item label="结算时间" v-if="js_type==0">
                            <el-date-picker  v-model="JS_edit_list.dealtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                        </el-form-item>
                         <el-form-item label="开票时间" v-if="js_type==1">
                            <el-date-picker  v-model="JS_edit_list.dealtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="人工费">
                            <el-input v-model="JS_edit_list.rgfee"  placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="租赁费">
                            <el-input v-model="JS_edit_list.zlfee"  placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" >
                    <el-button type="primary" @click="Que_js_edit">确认</el-button>
                    <el-button @click="JSedit = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="js_tit" :visible.sync="JSAdd" width="50%">
                <el-button type="primary" icon="el-icon-edit" @click="add_Js_list"></el-button>
                <el-table ref="multipleTable" :data="newJs" tooltip-effect="dark" style="width:90%;margin:0 auto"  max-height="180px">
                     <el-table-column   label="结算时间" v-if="js_tit=='添加结算'">
                          <template slot-scope="scope">
                              <el-date-picker  v-model="scope.row.jstime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                          </template>
                    </el-table-column>
                     <el-table-column   label="开票时间" v-if="js_tit=='添加开票'">
                          <template slot-scope="scope">
                              <el-date-picker  v-model="scope.row.jstime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                          </template>
                    </el-table-column>
                    <el-table-column   label="人工费">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.rgfee" placeholder=""></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column    label="租赁费">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.zlfee" placeholder="" type="number"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address"  label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="delJS(scope.$index)" style="margin-right:20px;" size="small">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                 <div slot="footer" class="dialog-footer"  >
                    <el-button type="primary" @click="Que_JS">确认</el-button>
                    <el-button @click="JSAdd = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="添加付款" :visible.sync="FkAdd" width="50%">
                <el-button type="primary" icon="el-icon-edit" @click="add_Fk_list"></el-button>
                <el-table ref="multipleTable" :data="newFk" tooltip-effect="dark" style="width:90%;margin:0 auto"  max-height="180px">
                     <el-table-column   label="付款时间">
                        <template slot-scope="scope">
                            <el-date-picker  v-model="scope.row.dealtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column   label="付款金额">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.rgfee" sortable placeholder="请输入" type="number"></el-input>
                        </template>    
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="delJS(scope.$index)" style="margin-right:20px;" size="small">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Que_fk">确认</el-button>
                    <el-button @click="FkAdd = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="付款修改" :visible.sync="FkEdit" width="50%">
                <el-form :inline="true" :model="fklist_redit" class="demo-form-inline">
                    <el-row :gutter="10">
                        <el-form-item label="付款时间">
                            <el-date-picker  v-model="fklist_redit.dealtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="付款金额">
                            <el-input v-model="fklist_redit.rgfee"  placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Que_fk_edit">确认</el-button>
                    <el-button @click="FkEdit = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="设备信息页" :visible.sync="shebei" width="70%">
                <el-form :inline="true" class="demo-form-inline">
                    <el-row :gutter="10" style="margin-left:5px;">
                        <el-form-item label="设备编号">
                            <el-input v-model="equipmentnum"  placeholder="请输入"></el-input>
                        </el-form-item>
                        <div style="float:right;">
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit_BH">查询</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="info" @click="clearS_BH">重置</el-button>
                            </el-form-item>
                        </div>
                    </el-row>
                </el-form>
                <el-table ref="multipleTable" :data="shebielist" tooltip-effect="dark" style="width:90%;margin:0 auto"  @selection-change="handleSelectionChanges" max-height="400px">
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column  prop="equipmentnum"  label="设备编号"> </el-table-column>
                    <el-table-column  prop="propertynum"  width="160" label="产权编号"> </el-table-column>
                    <el-table-column  prop="belonger" label="设备归属人"> </el-table-column>
                    <el-table-column   label="设备单价"> 
                        <template slot="header">
                            <span class="red">*</span>
                            <span>设备单价</span>
                        </template>  
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.price" sortable placeholder="请输入" type="number"></el-input>
                        </template>  
                    </el-table-column>
                    <el-table-column   label="人工单价"> 
                        <template slot="header">
                            <span  class="red">*</span>
                            <span>人工单价</span>
                        </template>  
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.rgprice" sortable placeholder="请输入" type="number"></el-input>
                        </template>  
                    </el-table-column>
                      <el-table-column   label="进场费用"> 
                        <template slot="header">
                            <span class="red">*</span>
                            <span>进场费用</span>
                        </template>  
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.jcfee" sortable placeholder="请输入" type="number"></el-input>
                        </template>  
                    </el-table-column>
                      <el-table-column   label="出场费用"> 
                         <template slot="header">
                            <span class="red">*</span>
                            <span>出场费用</span>
                        </template>  
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.ccfee" sortable placeholder="请输入" type="number"></el-input>
                        </template>  
                    </el-table-column>
                      <el-table-column   label="设备启用时间"> 
                        <template slot="header">
                            <span class="red">*</span>
                            <span>设备启用时间</span>
                        </template>  
                        <template slot-scope="scope">
                            <el-date-picker  v-model="scope.row.qytime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                        </template>  
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Que_shebei">确认</el-button>
                    <el-button @click="shebei = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog title="关闭" :visible.sync="ht_guanbi" width="40%">
                 <el-table ref="multipleTable" :data="guanbilist" tooltip-effect="dark" style="width:90%;margin:0 auto"  @selection-change="handleSelectionChanges" max-height="400px">
                    <el-table-column  prop="id"  label="设备ID"> </el-table-column>
                    <el-table-column  prop="equipmentnum"  label="设备编号"> </el-table-column>
                    <el-table-column    label="报停时间"> 
                        <template slot-scope="scope">
                            <el-date-picker  v-model="scope.row.bttime" type="date" placeholder="选择时间" value-format="yyyy-MM-dd" class="new_pick"> </el-date-picker>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Query_gb">确认</el-button>
                    <el-button @click="ht_guanbi = false">取 消</el-button>
                </div>
             </el-dialog>
        </div>
    </div>
</template>
<script>
import {newListHt,getList,openXmXq,editRk,htGuanBi,zd_Xq,zd_tj,HT_yjJsMoney,HT_YfMoney,HT_yjJsMoneyAdd,HT_yjJsMoneyEdit,HT_FKMoneyAdd,HT_FKMoneyEdit,kaipiao_list,kaipiao_Add,kaipiao_edit,sbxinxi,sbxinxitj,gbnum,del_ht,HT_yjJsMoneyDel} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            houseLis:[],
            ckid:'',
            cknum:'',
            equipmentnum:'',
            formInline: {
                contractname:'',
                cstatus_desc:''
            },
            ziduan:{
                kp_rgfee:'',
                kp_zlfee:''
            },
            rules: {
                contractname: [
                    { required: true, message: '请输入合同名称', trigger: 'blur' }
                ],
                contractnum: [
                    { required: true, message: '请输入合同编号', trigger: 'blur' }
                ],
                discount: [
                    { required: true, message: '请输入停滞折扣', trigger: 'blur' }
                ],
            },
            zd_id:'',
            chuKu:false,
            Money:false,
            zd:false,
            JS:false,
            JSedit:false,
            JSAdd:false,
            dialogFormVisible:false,
            FkAdd:false,
            FkEdit:false,
            ht_guanbi:false,
            fklist_redit:{},
            newJs:[],
            JS_edit_list:{},
            fk_type:1,
            fk_tit:"已付金额",
            zp_tit:"添加合同",
            js_tit:"添加结算",
            js_tit_two:'结算修改',
            js_type:0,
            newFk:[],
            tit_type:0,
            form:{
                contractname:'',
                contractnum:'',
                jine:'',
                cstatus:'',
                address:'',
                discount:'',
                contact:[],
                zjsjine:'',
            },
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            multipleSelections:[],
            tableData: [],
            fileList: [],
            pageNum:1,
            tableDatas: [],
            tableDataTwo:[],
            ht_id:'',
            shebei:false,
            shebielist:[],
            bttime:'',
            guanbilist:[],
            tableDatakp:[],
            zj_wfjine:'',
            zj_yfjine:'',
            zj_yjjsjine:'',
            zj_zjsjine:''
        };
    },
    methods:{
        
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            getList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:1,
                formInline:this.formInline
            }
            getList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        look(idx,id){
            this.dialogFormVisible=true
            if(idx==0){
                this.zp_tit="添加合同";
                this.tit_type=0;
                this.form={ contractname:'',
                contractnum:'',
                jine:'',
                cstatus:'',
                address:'',
                discount:'',
                contact:[]}
            }else if(idx==1){
                this.zp_tit="查看详情";
                this.tit_type=1;
                openXmXq({id:id}).then(res=>{
                   this.form=res
                })
            }else if(idx==2){
                this.zp_tit="编辑";
                this.tit_type=2;
                openXmXq({id:id}).then(res=>{
                   this.form=res;
                })
            }
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        add_user(){
            this.form.contact.push({name:'',tel:''})
        },
        delUser(index){
            this.form.contact.splice(index);
        },
        war(id){
            this.chuKu=true;
            this.ckid=id
        },
        Submit(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userId:this.user.uid,
                formInline:this.form,
            }
            newListHt(param).then(res=>{
                this.dialogFormVisible=false;
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                })
            })
        },
        clearS(){
            this.formInline={}
            getList().then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        edit_hetong(){
            this.form.cstatus=this.form.cstatus_desc;
        },
        editS(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userId:this.user.uid,
                formInline:this.form,
            }
            editRk(param).then(res=>{
                this.dialogFormVisible=false;
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                })
            })
        },
        tc_one(id){
            this.chuKu=true;
            HT_yjJsMoney({id:id}).then(res=>{
                console.log(res)
                this.tableDatas=res
            })
        },
        open_zd(id){
            this.zd_id=id;
            this.zd=true;
            kaipiao_list({id:id}).then(res=>{
               this.tableDatakp=res
            })
        },
        Que(){
            zd_tj({userId:this.user.uid,id:this.zd_id,ziduan:this.ziduan}).then(res=>{
                this.zd=false;
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                })
            })
        },
        //结算删除
        del_js(id,idx){ 
            this.$confirm('确定删除此条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    HT_yjJsMoneyDel({userId:this.user.uid,id:id}).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        if(idx==0){
                            HT_yjJsMoney({id:this.ht_id}).then(res=>{
                                this.tableDatas=res
                            })
                        }else if(idx==1){
                            kaipiao_list({id:this.zd_id}).then(res=>{
                                this.tableDatakp=res
                            })
                        }
                        
                        getList().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        jiesuan(id){
            this.JS=true;
            this.ht_id=id;
            HT_yjJsMoney({id:id}).then(res=>{
                this.tableDatas=res
            })
        },
        //结算修改
        jsedit(row,idx){
            this.JSedit=true;
            this.JS_edit_list=row;
            if(idx==0){
                this.js_tit_two='结算修改'
                this.js_type=0;
            }else if(idx==1){
                this.js_tit_two='开票修改'
                this.js_type=1;
            }
        },
        //结算修改提交
        Que_js_edit(){
            if(this.js_type==0){
                HT_yjJsMoneyEdit({userId:this.user.uid,jieSua:this.JS_edit_list}).then(res=>{
                    this.JSedit=false;
                    HT_yjJsMoney({id:this.ht_id}).then(res=>{
                        this.tableDatas=res
                    })
                    getList().then(res=>{
                        this.total=res.total,
                        this.tableData=res.list
                    });
                })
            }else if(this.js_type==1){
                kaipiao_edit({userId:this.user.uid,jieSua:this.JS_edit_list}).then(res=>{
                    this.JSedit=false;
                    kaipiao_list({id:this.zd_id}).then(res=>{
                        this.tableDatakp=res
                    })
                    getList().then(res=>{
                        this.total=res.total,
                        this.tableData=res.list
                    });
                })
            }
            
        },
        add_js(idx){
            if(idx==0){
                this.js_tit="添加结算"
                this.js_type=0;
            }else if(idx==1){
                this.js_tit="添加开票"
                this.js_type=1;
            }
            this.JSAdd=true;
            this.newJs=[];
        },
        add_Js_list(){
            this.newJs.push({jstime:'',rgfee:'',zlfee:''})
        },
        delJS(index){
            this.newJs.splice(index);
        },
        Que_JS(){
            if(this.js_type==0){
                HT_yjJsMoneyAdd({userId:this.user.uid,id:this.ht_id,jiesuan:this.newJs}).then(res=>{
                this.JSAdd=false;
                    HT_yjJsMoney({id:this.ht_id}).then(res=>{
                        this.tableDatas=res
                    });
                    getList().then(res=>{
                        this.total=res.total,
                        this.tableData=res.list
                    });
                })
            }else if(this.js_type==1){
                kaipiao_Add({userId:this.user.uid,id:this.zd_id,jiesuan:this.newJs}).then(res=>{
                this.JSAdd=false;
                    kaipiao_list({id:this.zd_id}).then(res=>{
                        this.tableDatakp=res
                    });
                    getList().then(res=>{
                        this.total=res.total,
                        this.tableData=res.list
                    });
                })
            }
            
        },
        getSummaries_s(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              // console.log(column)
            if (index === 0) {
                sums[index] = '总计';
                return;
            }
           
            if (index === 3) {
                sums[index] = '';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index] += ' 元';
                } else {
                    sums[index] = 'N/A';
                }
            });
            return sums;
        },
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              // console.log(column)
            if (index === 0) {
                sums[index] = '总计';
                return;
            }
            if (index === 1) {
                sums[index] = '';
                return;
            }
            if (index === 2) {
                sums[index] = '';
                return;
            }
            if (index === 4) {
                sums[index] = '';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            //console.log(values)
            if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index] += ' 元';
                } else {
                    sums[index] = 'N/A';
                }
            });
            return sums;
        },
        tc_two(id,type){
            this.Money=true;
            this.ht_id=id;
            HT_YfMoney({id:id}).then(res=>{
                console.log(res)
                this.tableDataTwo=res
            })
            if(type==1){
                this.fk_tit="已付金额";
                this.fk_type=1;
            }else if(type==2){
                this.fk_tit="付款金额";
                this.fk_type=2;
            }
        },
        //添加付款
        add_Fk(){
           this.FkAdd=true;
           this.newFk=[];
        },
        add_Fk_list(){
            this.newFk.push({dealtime:'',refee:''})
        },
        //付款提交
        Que_fk(){
            HT_FKMoneyAdd({userId:this.user.uid,id:this.ht_id,jiesuan:this.newFk}).then(res=>{
                this.FkAdd=false;
                HT_YfMoney({id:this.ht_id}).then(res=>{
                    this.tableDataTwo=res
                });
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        },
        //付款修改
        jseditfk(row){
            this.FkEdit=true;
            this.fklist_redit=row
        },
        //付款修该提交
        Que_fk_edit(){
            HT_FKMoneyEdit({userId:this.user.uid,jieSua:this.fklist_redit}).then(res=>{
                this.FkEdit=false;
                HT_YfMoney({id:this.ht_id}).then(res=>{
                    this.tableDataTwo=res
                });
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        },
        getSummariess(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              // console.log(column)
            if (index === 0) {
                sums[index] = '总计';
                return;
            }
            if (index === 2) {
                sums[index] = '';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            //console.log(values)
            if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index] += ' 元';
                } else {
                    sums[index] = 'N/A';
                }
            });
            return sums;
        },
        //租赁设备
        zulin(id){
            this.shebei=true;
            this.ht_id=id;
            sbxinxi().then(res=>{
                this.shebielist=res
            });
        },
        handleSelectionChanges(val) {
            this.multipleSelections = val;
            console.log(this.multipleSelections)
        },
        //租赁设备提交
        Que_shebei(){
            sbxinxitj({id:this.ht_id,shuzu:this.multipleSelections}).then(res=>{
                this.shebei=false;
                getList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        },
        open_zl(id){
            this.$router.push({
                path:'/Warehouse',
                query:{
                     id:id
                }
            })
        },
        guanBi(id){
            this.ht_guanbi=true;
            gbnum({id:id}).then(res=>{
                this.guanbilist=res
            });
            
            this.ht_id=id;
        },
        Query_gb(){
            htGuanBi({userId:this.user.uid,id:this.ht_id,btarr:this.guanbilist}).then(res=>{
                this.$message({
                    type: 'success',
                    message: '关闭成功!'
                });
                this.ht_guanbi=false;
                getList().then(res=>{
                    this.total=res.total;
                    this.tableData=res.list
                });
            });
        },
        del(id){
            this.$confirm('确定删除此条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    del_ht({userId:this.user.uid,id:id}).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        getList().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        //查询
        onSubmit_BH(){
            sbxinxi({equipmentnum:this.equipmentnum}).then(res=>{
                this.shebielist=res
            });
        },
        clearS_BH(){
            this.equipmentnum='';
            sbxinxi().then(res=>{
                this.shebielist=res
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            numPerPage:this.value,
            pageNum:this.pageNum,
            formInline:this.formInline
        }
        getList(param).then(res=>{
            this.total=res.total,
            this.tableData=res.list,
            this.zj_wfjine=res.zj_wfjine,
            this.zj_yfjine=res.zj_yfjine,
            this.zj_yjjsjine=res.zj_yjjsjine,
            this.zj_zjsjine=res.zj_zjsjine
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
      .el-image{
        margin-right:30px;
    }
    .new_pick.el-date-editor.el-input{
        width:156px;
    }
    .red{
        color:red;
    }
</style>



// WEBPACK FOOTER //
// src/components/Warehousing.vue